import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { msgAppHandler, translate } from '../../../utils/util';

const LoadUnloadHome = (props) => {

    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, {
            route: './parametersConfirmation',
            icon: 'local_shipping',
            text: translate('menu:load-unload')
        }];


        menuItems = [...menuItems, {
            route: './logs',
            icon: 'chrome_reader_mode', text: 'Logs'
        },
        {
            route: './shedconfig',
            icon: 'mdi mdi-cogs', text: 'Config Carga x Galpão'
        },
        ];
        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('menu:load-unload')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoadUnloadHome));